import React, { Fragment } from 'react';
import { useQuery } from 'react-query';

import {
    TitleContainer,
    Paragraph,
    ColumnContainer,
    Column,
    SectionTitle,
    CardContainer,
} from "@beacharound/beacharound-ui";

import { formatDate, isMobile } from "@beacharound/beacharound-ui-helpers";
import { getPromotions } from '../../api/promotions';

// const beachConnectText = [
//     "<strong>Iscriviti</strong><br/> Accedi ad il tuo account e inizia ad occuparti della pagina della tua struttura",
//     "<strong>Fai crescere la tua attività</strong> <br/> Inserisci foto, descrizione e tutto quello che un ospite dovrebbe sapere prima di soggiornare nella tua struttura. Amplia la tua visibilità sul web gratuitamente.",
//     "<strong>Rivolgiti ai tuoi ospiti ideali</strong><br/> Il nostro marketplace è utilizzato per ricercare le spiagge da migliaia di utenti tutti i giorni. Attira nuovi clienti e fai conoscere la tua attività."
// ]

export default function BeachesPromotionsHighlight({ match }) {

    const { beachSlug } = match.params;

    const { data: promotions } = useQuery(["promotions", beachSlug], () =>
        getPromotions({ activitySlug: beachSlug }),
        {
            refetchOnWindowFocus: false
        }
    )

    if(!promotions?.length > 0) {
        return <Fragment></Fragment>
    }

    const promotion = promotions?.[0];

    return (
        <ColumnContainer lowMargin>
            <Column>
                <CardContainer>
                    <TitleContainer noMargin>
                        <ColumnContainer noMargin>
                            <Column column={2}>
                                <Paragraph color="main" text="<strong>Promozione in corso!</strong>" larger/>
                            </Column>
                            <Column column={2}>
                                <SectionTitle text={`-${promotion.value}% fino al ${formatDate(new Date(promotion.toDate), 'dd MMMM')}`} right={!isMobile()}/>
                            </Column>
                        </ColumnContainer>
                        {promotion.name && <Paragraph text={promotion.name} larger/>}
                        {promotion.description && <Paragraph text={promotion.description}/>}
                    </TitleContainer>
                </CardContainer>
            </Column>
        </ColumnContainer>
    );
}